import { FC } from 'react';

const YoutubeFrame: FC<{ embedId: string }> = ({ embedId }) => (
  <div className="video-responsive">
    <iframe
      allowFullScreen
      title="bookitup"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      style={{ borderRadius: 10 }}
    />
  </div>
);

export default YoutubeFrame;
